import {AxiosInstance} from "axios";
import API from "../../utils/api";
import {AccountingSummaryItem} from "../../models/accounting/summary";

export class SummaryService {
    api: AxiosInstance = API;

    getSummary(): Promise<AccountingSummaryItem[]> {
        return this.api.get('accounting/summary/statistic')
            .then((x) => x.data);
    }
}

export const summaryService = new SummaryService();